<script>
  export { className as class }

  let className = ""
</script>

<div class="{className} content-container [ px-[8vw] md:px-[6vw] lg:px-[4vw] xl:px-[3vw] ]">
  <slot />
</div>
